import { HiChevronRight } from 'react-icons/hi2';
import {
  LiaCalendar,
  LiaPillsSolid,
  LiaShieldAltSolid,
  LiaTagsSolid,
} from 'react-icons/lia';
import { useOutletContext } from 'react-router-dom';

import { Button } from '@/components-new/button';
import { SectionDescription, SectionHeading } from '@/components-new/section';
import { Classification } from '@/features/classifications/types/classification';

type OutletContext = { classification: Classification | undefined };

type StatCardProps = {
  icon: React.ReactNode;
  iconBg: string;
  label: string;
  value: number | undefined;
};

const StatCard = ({ icon, iconBg, label, value }: StatCardProps) => (
  <div className="rounded-xl border border-zinc-200 bg-white p-5">
    <div className="flex items-center gap-4">
      <div className={`flex size-10 shrink-0 items-center justify-center rounded-lg text-white ${iconBg}`}>
        {icon}
      </div>
      <div>
        <p className="text-sm font-medium text-zinc-500">{label}</p>
        <p className="text-2xl font-bold text-zinc-900">{value ?? '—'}</p>
      </div>
    </div>
  </div>
);

const ClassificationOverviewPage = () => {
  const { classification } = useOutletContext<OutletContext>();

  return (
    <div className="mt-4 flex flex-col gap-8">

      {/* Stats */}
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <StatCard
          icon={<LiaPillsSolid className="size-5" />}
          iconBg="bg-slate-500"
          label="Drugs"
          value={classification?.drugCount}
        />
        <StatCard
          icon={<LiaCalendar className="size-5" />}
          iconBg="bg-emerald-600"
          label="Upcoming Meetings"
          value={classification?.boardMeetingCount}
        />
        <StatCard
          icon={<LiaShieldAltSolid className="size-5" />}
          iconBg="bg-indigo-600"
          label="MCO Carve-Outs"
          value={classification?.mcoCarveOutCount}
        />
        <StatCard
          icon={<LiaTagsSolid className="size-5" />}
          iconBg="bg-amber-600"
          label="PDL Exemptions"
          value={classification?.pdlExemptionCount}
        />
      </div>

      {/* Therapeutic Class Report CTA */}
      <div className="rounded-xl border border-zinc-200 bg-white p-6">
        <div className="flex items-center justify-between">
          <div>
            <SectionHeading level={3}>Therapeutic Class Report</SectionHeading>
            <SectionDescription>
              Compare coverage across states for all drugs in the {classification?.name} classification.
            </SectionDescription>
          </div>
          <Button outline href={`/market-reports/therapeutic-class-report?classificationId=${classification?.id}`}>
            <HiChevronRight />
            View Report
          </Button>
        </div>
      </div>

    </div>
  );
};

export default ClassificationOverviewPage;
